export function notInitialized(): never {
    throw new Error('Widget not initialized')
}
